// Packages
import tw, { styled } from "twin.macro";

export const Container = styled.div(() => [
  ``,
  tw`absolute top-10 z-50 right-8 lg:right-24`,
]);

export const Icon = styled.div(() => [
  ``,
  tw`mr-2`,
]);

export const Select = styled.select(() => [
  ``,
  tw`appearance-none bg-none bg-transparent text-[#006FCF]`,
]);
